import { useQuery } from '@tanstack/react-query'

import { CORPORATE_ENROLLMENT_QUERY_KEY } from '@/constants/corporateQueryKeys'
import { getCorporate, RequestError } from '@/requests/corporate'
import type { CorporateEnrollment } from '@/utils/corporateResume'

export const useCorporateEnrollment = (enabled: boolean) =>
  useQuery<CorporateEnrollment | null>({
    queryKey: CORPORATE_ENROLLMENT_QUERY_KEY,
    enabled,
    staleTime: 0,
    retry: false,
    queryFn: async () => {
      const res = await getCorporate()
      if (res.status === 404) return null
      if (res.status !== 200) {
        throw new RequestError(
          'Could not load your corporate enrollment',
          res.status
        )
      }
      return (res.data as { data: CorporateEnrollment }).data
    },
  })
